import MyLocale from '@/models/MyLocale.model';

export const mk = new MyLocale({
	title: 'WB-CPP',

	word: {
		to: 'до',
	},
	message: {
    emptyState: {
      noData: {
        title: 'Нема пронајдени податоци!',
        message: 'Нема пронајдени податоци!',
      },
      unknownAuthor: {
        title: 'Непознат автор!',
        message: 'Непознат автор!',
      },
    },
	},
	filters: {
		dataType: {
			title: 'Климатски увид по извор на податоци',
      info: 'Истражете ги набљудуваните податоци и сценаријата базирани на модел за клучните климатски променливи.',
			observation: {
				title: 'Историски',
			},
			scenario: {
				title: 'Сценарио',
			},
      mapInfoTitle: 'Сет на податоци',
		},
		variable: {
			title: 'Променлива',

			// New variables
			cdd5: 'cdd5',
			cdd7: 'cdd7',
			dhi5: 'dhi5',
			dhi7: 'dhi7',
			ews: 'ews',
			ewc: 'ewc',
			ftd: 'ftd',
			hd30: 'hd30',
			hd40: 'hd40',
			ls: 'ls',
			sdii: 'sdii',
			hs: 'hs',
			sd: 'sd',
			pr: 'pr',
			tmean: 'tmean',
			tasmax: 'tasmax',
			tasmin: 'tasmin',

			// Tooltips for new variables
			cdd5Tooltip: 'cdd5',
			cdd7Tooltip: 'cdd7',
			dhi5Tooltip: 'dhi5',
			dhi7Tooltip: 'dhi7',
			ewsTooltip: 'ews',
			ewcTooltip: 'ewc',
			ftdTooltip: 'ftd',
			hd30Tooltip: 'hd30',
			hd40Tooltip: 'hd40',
			lsTooltip: 'ls',
			sdiiTooltip: 'sdii',
			hsTooltip: 'hs',
			sdTooltip: 'sd',
			prTooltip: 'pr',
			tmeanTooltip: 'tmean',
			tasmaxTooltip: 'tasmax',
			tasminTooltip: 'tasmin',

			// Titles for new variables
			cdd5Title: 'Суви периоди (5 дена)',
			cdd7Title: 'Суви периоди (7 дена)',
			dhi5Title: 'Топли денови во суви периоди (5 дена)',
			dhi7Title: 'Топли денови во суви периоди (7 дена)',
			ewsTitle: 'Екстреми на брзина на ветер',
			ewcTitle: 'Денови со екстремни брзини на ветер',
			ftdTitle: 'Циклуси на замрзнување и одмрзнување',
			hd30Title: 'Топли денови (30 °C)',
			hd40Title: 'Топли денови (40 °C)',
			lsTitle: 'Критични услови на врнежи за свлечишта',
			sdiiTitle: 'Екстреми на врнежи',
			hsTitle: 'Интензивни снежни врнежи',
			sdTitle: 'Снег',
			prTitle: 'Количина на врнежи',
			tmeanTitle: 'Средна температура',
			tasmaxTitle: 'Максимална температура',
			tasminTitle: 'Минимална температура',

      cdd5Description: 'Денови во последователни периоди од 5 дена со помалку од 1mm врнежи во април-септември',
      cdd7Description: 'Денови во последователни периоди од 7 дена со помалку од 1mm врнежи во април-септември',
      dhi5Description: 'Денови во 5-дневни суви периоди со максимална дневна температура над 30°C',
      dhi7Description: 'Денови во 7-дневни суви периоди со максимална дневна температура над 30°C',
      ewsDescription: '99,9 перцентил на дневни средни брзини на ветер во периодот 1981-2010',
      ewcDescription: 'Денови кои го надминуваат 99,9 перцентилот на дневни средни брзини на ветер во периодот 1981-2010',
      ftdDescription: 'Денови со минимална температура под -2.2°C и максимална над 0°C',
      hd30Description: 'Денови со максимална температура над 30°C',
      hd40Description: 'Денови со максимална температура над 40°C',
      lsDescription: 'Денови кои ги надминуваат праговите на интензитет на врнежи според методата на Moser-Hohensinn (M = 41.66 * (h^-0.77) * h) за h = 24, 48 и 72 часа',
      sdiiDescription: '99,9 перцентил на дневни количества врнежи во периоди од 30 години',
      hsDescription: 'Денови со количество врнежи над 10mm и средна температура под 0°C',
      sdDescription: 'Денови со количество врнежи над 1mm и средна температура под 0°C',
      prDescription: 'Дневно количество врнежи',
      tmeanDescription: 'Дневна средна температура на воздухот',
      tasmaxDescription: 'Дневна максимална температура на воздухот',
      tasminDescription: 'Дневна минимална температура на воздухот',

		},
		period: {
			title: 'Период',
      '1981-2010': '1981-2010',
      '2011-2040': '2011-2040',
      '2001-2020': '2001-2020',
      '2036-2065': '2036-2065',
      '2071-2100': '2071-2100',
		},
    scenario: {
      title: 'Сценарио',
      ens: 'ENS',
      rcp26: 'RCP2.6 (сценарио со ниски емисии)',
      rcp45: 'RCP4.5 (сценарио со умерени емисии)',
      rcp85: 'RCP8.5 (сценарио со високи емисии)',
    },
		season: {
			title: 'Сезона',
      'yr': 'Година',
      '01': 'Јануари',
      '02': 'Февруари',
      '03': 'Март',
      '04': 'Април',
      '05': 'Мај',
      '06': 'Јуни',
      '07': 'Јули',
      '08': 'Август',
      '09': 'Септември',
      '10': 'Октомври',
      '11': 'Ноември',
      '12': 'Декември',
		},
		gwl: {
			title: 'Ниво на глобално затоплување',
      '1.5': 'GWL1.5',
      '2.0': 'GWL2.0',
      '3.0': 'GWL3.0',
      '4.0': 'GWL4.0',
		},
		gridSpacing: {
			title: 'Растојание помеѓу мрежите',
      '01deg': '01deg',
		},
		author: {
      title: 'Автор',
      defaultLabel: 'Изберете автор',
    }
	},
	options: {
		download: {
			image: 'Слика',
			pdf: 'PDF',
			file: 'Датотека',
		},
	},
	legend: {
		min: 'min',
		max: 'max',
	},
	mapDetails: {
		value: 'Вредност',

		ens: 'Медијана',
    ens75: '75-ти перцентил',
    ens25: '25-ти перцентил',

    noCsvData: 'Нема csv податоци за оваа точка',
    subgridToggleLabel: 'Прикажи 30arcsec мрежа',
    subgridToggleOnInfo: 'Овозможувањето на 30arcsec мрежата за оваа ќелија исто така ќе прикаже 30arcsec мрежа за сите соседни ќелии.',
    subgridToggleOffInfo: 'Изберете 30arcsec ќелија за да ги прегледате нејзините податоци.',
	},
	tour: {
		closeButton: 'Close',
		backButton: 'Back',
		nextButton: 'Next',
		completeButton: 'Complete',
		startButton: 'Start platform tour',
	},
	unit: {
    Celsius: '°C',
		'%': '%',
		mm: 'mm',
    d: 'd',
    'm s-1': 'm s-1',
	},
  mapView: {
    noneValue: 'Без мапа',
    terrain: 'Терен мапа',
    satellite: 'Сателитска мапа',
  },
  mapOptions: {
    showClimateData: 'Прикажи климатски податоци',
  },
  footer: {
    kosovoBorderLabel: 'Оваа одредба е без предрасуди кон ставовите за статусот и е во согласност со UNSCR 1244/99.',
  },
  nav: {
    map: 'Мапа',
  },
});
